<div id="tour-date-range-selector" class="pro-options__range">
  <div id="slider"></div>
</div>
<div class="pro-options__print-range">
  Date Range: <strong>{{ dateRange.startDate | date: 'LLL yyyy' }} to {{ dateRange.endDate | date: 'LLL yyyy' }}</strong>
</div>
